import { Component } from '@angular/core';
import { IonicPage, NavController,AlertController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
import { LoginPage } from '../login/login';

/**
 * Generated class for the SetNewPasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-set-new-password',
  templateUrl: 'set-new-password.html',
})
export class SetNewPasswordPage {
   mobile:any="";
   errorDisplay:any={};
   password:any=""
   confirm_password:any=""
  constructor(private loadingCtrl:LoadingController,private alertCtrl:AlertController,
    private fv:GenericFormValidationProvider, public navCtrl: NavController,
    public navParams: NavParams,private cp:CommonProvider) {
    this.mobile=this.navParams.get("mobile")
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad SetNewPasswordPage');
  }
  postFormForValidation(pd){
   this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[])
   if(this.errorDisplay.valid){
    return false;
  }else{
     let loading = this.loadingCtrl.create({
            content: 'Please wait...'
          });
     loading.present()
   this.cp.updatePassword(loading,pd,this.mobile).then((res:any)=>{
    loading.dismiss();

      var res=JSON.parse(res);
      if(typeof(res)=='string'){
        res=JSON.parse(res);
      }
      if(res.Payload.Message=="SUCCESS" ){
        this.showAlert("SUCCESS","Password updated successfully");
        // alert("password update successfully");
        this.navCtrl.setRoot(LoginPage)
        
      }
   }).catch((err:any)=>{
        loading.dismiss();
    //console.log("invalid");
   })
  }
  }
  showAlert(title,msg) {

      let masg=msg;
      const alert = this.alertCtrl.create({
        title: title,
        subTitle: masg,
        buttons: ['OK']
      });
      alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/set-new-password/set-new-password.ts